export default __webpack_public_path__ + "static/media/Trapper's Bolts.dcc8b08b.jpg";